import { Component, Input } from '@angular/core';
import { Report } from '../../models/Report';
import { ReportsProvider } from '../../providers/reports/reports';
import { LoadingController, ToastController } from 'ionic-angular';
@Component({
    selector: 'report-list',
    templateUrl: 'report-list.html'
})
export class ReportListComponent {
    @Input('stocks') stocks: boolean = false;

    reports: Report[] = [];
    allReports: Report[] = [];
    hasLoaded: boolean = false;

    constructor(
        public reportsCtrl: ReportsProvider,
        public loadingCtrl: LoadingController,
        public toastCtrl: ToastController
    ) {

    }

    ngOnInit(){
        let loader = this.loadingCtrl.create();
        loader.present();

        this.reportsCtrl.getAllReports(this.stocks).subscribe(reports => {
            this.allReports = reports;
            this.reports = [];
            this.hasLoaded = true;
            this.loadMoreReports();
            loader.dismiss();
        }, error => {
            this.toastCtrl.create({ message: error, duration: 3000 }).present();
            loader.dismiss();
        })
    }

    getMoreItems(infiniteScroll) {
        this.loadMoreReports();
        infiniteScroll.complete();
    }
    loadMoreReports() {
        let start = this.reports.length;
        let end = start + 14;

        if (end >= this.allReports.length) {
            end = this.allReports.length - 1;
        }
        for (let i = start; i <= end; i++) {
            this.reports.push(this.allReports[i]);
        }
    }
    getMoreItemsButton(event) {
        this.loadMoreReports();
    }

}



// WEBPACK FOOTER //
// ./src/components/report-list/report-list.ts